import styled from '@emotion/styled';
import { DataObject, Label, Password, UploadFile } from '@mui/icons-material';
import MenuIcon from '@mui/icons-material/Menu';
import {
  Box,
  Button,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material';
import PermissionGuard from 'hooks/permissions/PermissionGuard';
import { permissions } from 'hooks/permissions/permissions';
import { usePermissions } from 'hooks/permissions/usePermissions';
import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';

import BranchWithCodeSubmitModal from '../BranchWithCodeSubmitModal/BranchWithCodeSubmitModal';
import BranchWithUploadSubmitModal from '../BranchWithUploadSubmitModal/BranchWithUploadSubmitModal';

const ProductDetailHeader = ({
  detail,
  setProductGallery,
  setProductLabel,
  guid,
}) => {
  const { description, imageURL, preFix, labels, title } = detail;

  const [isBranchWithCodeModalOpen, setIsBranchWithCodeModalOpen] =
    useState(false);
  const [isBranchWithUploadModalOpen, setIsBranchWithUploadModalOpen] =
    useState(false);
  const [isLabelInsertModalOpen, setIsLabelInsertModalOpen] = useState(false);
  const [isTechspecificationsModalOpen, setIsTechspecificationsModalOpen] =
    useState(false);

  const [anchorEl, setAnchorEl] = useState(null);

  const { can } = usePermissions();

  const openMenu = Boolean(anchorEl);

  const handleClickMenu = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const productDetailPermissions =
    permissions.general.categories.globalSettings.productManagement.productList
      .detail;

  const menuItems = useMemo(
    () => [
      {
        label: 'ثبت برنچ با کد',
        permission: productDetailPermissions.branch.createByCode,
        icon: Password,
        color: 'success',
        onClick: () => {
          handleCloseMenu();
          setIsBranchWithCodeModalOpen(true);
        },
      },
      {
        label: 'آپلود برنچ',
        permission: productDetailPermissions.branch.upload,
        icon: UploadFile,
        color: 'success',
        onClick: () => {
          handleCloseMenu();
          setIsBranchWithUploadModalOpen(true);
        },
      },
      {
        label: 'ثبت برچسب',
        permission: productDetailPermissions.insertLabel,
        icon: Label,
        color: 'primary',
        onClick: () => {
          handleCloseMenu();
          setIsLabelInsertModalOpen(true);
        },
      },
      {
        label: 'مشخصات فنی',
        permission: productDetailPermissions.viewTechSpecifications,
        icon: DataObject,
        color: 'info',
        onClick: () => {
          handleCloseMenu();
          setIsTechspecificationsModalOpen(true);
        },
      },
    ],
    [],
  );

  const visibleMenuItems = menuItems.filter(item => can(item.permission));

  return (
    <Wrapper>
      <Grid container spacing={5}>
        <Grid item xs={12} md={3}>
          <HeaderImage>
            {!!imageURL ? <Image src={imageURL} /> : <p>بدون تصویر</p>}
          </HeaderImage>
        </Grid>

        <Grid item xs={12} md={9}>
          <FiledWrapper>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={3} md={4} lg={3}>
                <Ques>عنوان</Ques>
              </Grid>

              <Grid item xs={12} sm={9} md={8} lg={9}>
                <Describtion>{title}</Describtion>
              </Grid>
            </Grid>
          </FiledWrapper>

          <FiledWrapper>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={3} md={4} lg={3}>
                <Ques>توضیحات</Ques>
              </Grid>

              <Grid item xs={12} sm={9} md={8} lg={9}>
                <Describtion>
                  {!!description ? <>{description} &nbsp;</> : ''}
                </Describtion>
              </Grid>
            </Grid>
          </FiledWrapper>

          <FiledWrapper>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={3} md={4} lg={3}>
                <Ques>پیشوند</Ques>
              </Grid>

              <Grid item xs={12} sm={9} md={8} lg={9}>
                <Describtion>
                  {!!preFix ? <>{preFix} &nbsp;</> : ''}
                </Describtion>
              </Grid>
            </Grid>
          </FiledWrapper>

          <FiledWrapper>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={3} md={4} lg={3}>
                <Ques>برچسب‌ ها</Ques>
              </Grid>

              <Grid item xs={12} sm={9} md={8} lg={9}>
                <Describtion>
                  {!!labels ? <>{labels} &nbsp;</> : ''}
                </Describtion>
              </Grid>
            </Grid>
          </FiledWrapper>
        </Grid>
      </Grid>

      <Box
        sx={{
          w: 'full',
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          marginTop: '45px',
          flexWrap: 'wrap',
          gap: 1,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            gap: 1,
          }}
        >
          <PermissionGuard permission={productDetailPermissions.branch.create}>
            <Link
              to={`/shop/products/${guid}/branch-insert`}
              sx={{ width: 'auto' }}
            >
              <BranchButton
                variant="contained"
                size="small"
                sx={{
                  backgroundColor: '#27348b',
                }}
              >
                ثبت برنچ
              </BranchButton>
            </Link>
          </PermissionGuard>

          <PermissionGuard permission={productDetailPermissions.gallery}>
            <BranchButton
              variant="contained"
              size="small"
              color="warning"
              onClick={setProductGallery}
            >
              گالری
            </BranchButton>
          </PermissionGuard>
        </Box>

        {visibleMenuItems.length > 0 && (
          <div>
            <IconButton
              id="product-head-accordion-button"
              aria-controls={
                openMenu ? 'product-head-accordion-menu' : undefined
              }
              aria-haspopup="true"
              aria-expanded={openMenu ? 'true' : undefined}
              onClick={handleClickMenu}
            >
              <MenuIcon />
            </IconButton>

            <Menu
              id="product-head-accordion-menu"
              aria-labelledby="product-head-accordion-button"
              anchorEl={anchorEl}
              open={openMenu}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              onClose={handleCloseMenu}
            >
              {visibleMenuItems.map(item => {
                const Icon = item.icon;

                return (
                  <MenuItem key={item.permission} onClick={item.onClick}>
                    <Action>
                      <Typography fontSize={14}>{item.label}</Typography>

                      <Icon fontSize="small" color={item.color} />
                    </Action>
                  </MenuItem>
                );
              })}
            </Menu>
          </div>
        )}
      </Box>

      <BranchWithCodeSubmitModal
        originGuid={guid}
        open={isBranchWithCodeModalOpen}
        setOpen={() => setIsBranchWithCodeModalOpen(true)}
        handleClose={() => setIsBranchWithCodeModalOpen(false)}
      />

      <BranchWithUploadSubmitModal
        originGuid={guid}
        open={isBranchWithUploadModalOpen}
        setOpen={() => setIsBranchWithUploadModalOpen(true)}
        handleClose={() => setIsBranchWithUploadModalOpen(false)}
      />
    </Wrapper>
  );
};

export default ProductDetailHeader;

const Wrapper = styled.div`
  margin-bottom: 30px;
`;

const HeaderImage = styled.div``;

const Image = styled.img`
  display: block;
  max-width: 100%;
  margin: 0 auto;
`;

const FiledWrapper = styled.div`
  color: #707070;
  margin-top: 10px;

  @media all and (max-width: 600px) {
    margin-top: 20px;
  }
`;

const Ques = styled.p`
  padding: 15px;
  background-color: #f4f4f4;
  border-radius: 15px;
`;

const Describtion = styled.p`
  padding: 15px;
  background-color: #f4f4f4;
  border-radius: 15px;
  min-height: 54px;
`;

const BranchButton = styled(Button)``;

const Action = styled(Box)({
  paddingTop: '0.3rem',
  paddingBottom: '0.3rem',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: '0.5rem',
});
